import { FormattedMessage } from 'react-intl';
import { styled } from '@mui/material/styles';
import { useNavigate } from 'react-router';
import Button from '@/components/Button/Button';
import SharedBasketMessageCard from './SharedBasketMessageCard';

const SharedBasketInactive = ({
  kind,
}: {
  kind: 'expired' | 'disabled';
}) => {
  const navigate = useNavigate();
  const expired = kind === 'expired';

  return (
    <SharedBasketMessageCard
      icon={expired ? '⏳' : '🚫'}
      title={
        expired ? (
          <FormattedMessage
            id="sharedBasketExpiredTitle"
            defaultMessage="This link has expired"
          />
        ) : (
          <FormattedMessage
            id="sharedBasketDisabledTitle"
            defaultMessage="This link was disabled"
          />
        )
      }
      body={
        expired ? (
          <FormattedMessage
            id="sharedBasketExpiredBody"
            defaultMessage="The files themselves haven't gone anywhere — ask whoever sent it for a fresh link."
          />
        ) : (
          <FormattedMessage
            id="sharedBasketDisabledBody"
            defaultMessage="Whoever shared it turned it off. The files themselves haven't gone anywhere — ask them for a fresh link."
          />
        )
      }
    >
      <FullWidthButton
        variant="contained"
        onClick={() => navigate('/')}
        aria-label="Browse the portal"
      >
        <FormattedMessage
          id="browseThePortal"
          defaultMessage="Browse the portal"
        />
      </FullWidthButton>
    </SharedBasketMessageCard>
  );
};

const FullWidthButton = styled(Button)({
  width: '100%',
  justifyContent: 'center',
});

export default SharedBasketInactive;
